/**
 * Utility functions for number compacting.
 * @param number - The number to be compacted.
 * @param maximumFractionDigits - The maximum number of fraction digits to display.
 * @returns {*|string} - The compacted number as a string, or the original number if it is not a valid number.
 */
export const compactNumber = (number, maximumFractionDigits = 0) => {
  if (!Number(number)) return number;

  return new Intl.NumberFormat('en', {
    notation: 'compact',
    compactDisplay: 'short',
    maximumFractionDigits
  }).format(number);
};
